import type { ResolverTag } from '@ps/web-core-enums';
import { useResolver } from '@ps/web-shared-components';
import { useSelector } from 'react-redux';

import { select } from '@swf/core/store';
import { EMBEDDED_RESOLVER_PREFIX } from '@swf/poker';

const useResolvedLink = (resolver: ResolverTag): string => {
  const isEmbedded = useSelector(select.device.isDesktopEmbedded);
  const defaultLink = useResolver(resolver);
  const embeddedLink = EMBEDDED_RESOLVER_PREFIX + resolver;
  return isEmbedded ? embeddedLink : defaultLink;
};

export default useResolvedLink;
